<template>
    <el-select
            :value="value"
            filterable
            clearable
            remote
            placeholder="Search Contacts"
            :remote-method="search"
            :loading="loading"
            popperClass="custom-popper"
            @input="onInput"
            value-key="id"
    >
        <el-option
                v-for="item in options"
                :key="item.id"
                :label="format(item)"
                :value="item"
        ></el-option>
    </el-select>
</template>

<script>
  import {addQueryParams} from "../libs/url";

  export default {
    props: {
      url: String,
      value: null,
    },

    data() {
      return {
        loading: false,
        options: [],
      };
    },

    methods: {
      /**
       * @return {undefined}
       */
      search(text) {
        this.loading = true;
        const url = addQueryParams(this.url, {text});
        axios.get(url)
          .then(this.onSuccess)
          .catch(this.onError)
          .finally(() => {
            this.loading = false;
            this.$emit('search', {hasContacts: !_.isEmpty(this.options)});
          })
      },

      /**
       * @param {Object} data
       * @return {undefined}
       */
      onSuccess({data}) {
        this.options = _.get(data, 'data');
      },

      /**
       * @param {Object} response
       * @return {undefined}
       */
      onError({response}) {
        this.options = [];
      },

      /**
       * @param {Object} item
       * @return {string}
       */
      format(item) {
        const phoneNumber = _.get(item, 'phone_number');
        const fullName = _.get(item, 'full_name');
        return fullName + (_.isEmpty(phoneNumber) ? '' : ` (${phoneNumber})`);
      },

      /**
       * @param {*} value
       */
      onInput(value) {
        this.$emit('input', value || null);
      },
    },
  }
</script>
